import type { StepConfig } from '../../types/workflow';

const openConversation: StepConfig = {
  // Design
  icon: 'openConversation',
  headerTextColor: '#43B284',
  headerColor: '#D8F1E7',
  title: 'Open Conversation',
  text: '',
  category: 'Node',
  desc: 'Opens a conversation for the contact.',

  // Form
  formFields: [],
};

export default openConversation;
